import {
  GUI_TIN_NHAN,
  GUI_TIN_NHAN_SUCCESS,
  GUI_TIN_NHAN_FAILURE,
  SHOW_GUI_TIN_NHAN,
} from "actions/GuiTinNhan/actionTypes";

const initialState = {
  guiTinNhanLoading: false,
  showModalTinNhan: false,
};

const guiTinNhan = (state, action) => ({
  ...state,
  guiTinNhanLoading: true,
});

const guiTinNhanSuccess = (state, action) => {
  return {
    ...state,
    guiTinNhanLoading: false,
    showModalTinNhan: false,
  };
};

const guiTinNhanFailed = (state, action) => ({
  ...state,
  guiTinNhanLoading: false,
});
const showModalGuiTinNhan = (state, action) => {
  return {
    ...state,
    showModalTinNhan: !state.showModalTinNhan,
  };
};

const guiTinNhanReducer = (state = initialState, action) => {
  switch (action.type) {
    case GUI_TIN_NHAN:
      return guiTinNhan(state, action);
    case GUI_TIN_NHAN_SUCCESS:
      return guiTinNhanSuccess(state, action);
    case GUI_TIN_NHAN_FAILURE:
      return guiTinNhanFailed(state, action);
    case SHOW_GUI_TIN_NHAN:
      return showModalGuiTinNhan(state, action);
    default:
      return state;
  }
};

export default guiTinNhanReducer;
